module.exports = __webpack_public_path__ + "static/media/dibari1.e77e936e.jpg";